import React from "react";

const Heading = ({ title, subTitle }) => {
  return (
    <>
      <p className="text-dark text-base sm:text-lg font-['Poppins'] mb-4 sm:mb-8">
        <span className="mr-2.5">||</span> <span>{subTitle}</span>
      </p>
      <h1 className="text-light text-2xl sm:text-4xl md:text-5xl font-['Merriweather']">
        {title}
      </h1>
    </>
  );
};

export default Heading;
